const formatter = new Intl.NumberFormat('en-US')

export const formatFullNumber = (num: number) => formatter.format(num)
